import React from 'react'

const StiMap = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 pb-5' >
        <iframe style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.25)'}} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d23778.055555501203!2d-88.012268!3d41.844296!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e4da6871ee89f%3A0x536bf96dd44abca8!2sUnited%20Lab%20Care!5e0!3m2!1sen!2sus!4v1695383228654!5m2!1sen!2sus" width="100%" height="320" title="United Lab Care"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </div>
  )
}

export default StiMap